import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Camera } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = [
  { url: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=900&q=80&auto=format&fit=crop", caption: "Ouverture de bal" },
  { url: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=900&q=80&auto=format&fit=crop", caption: "Soirée dansante" },
  { url: "https://images.unsplash.com/photo-1519741497674-611481863552?w=900&q=80&auto=format&fit=crop", caption: "Vin d'honneur" },
  { url: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=900&q=80&auto=format&fit=crop", caption: "Jeux de lumière" },
];

export default function Gallery() {
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    axios.get(`${API}/gallery`).then((r) => setPhotos(r.data)).catch(() => {});
  }, []);

  const items = photos.length
    ? photos.map((p) => ({ url: `${API}/gallery/${p.id}/image`, caption: p.caption || "Événement KLMProd", id: p.id }))
    : FALLBACK;

  return (
    <section id="galerie" className="relative py-28 sm:py-36" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          testId="gallery-heading"
          eyebrow="Galerie"
          title={
            <>
              Nos soirées <span className="text-gradient">en images.</span>
            </>
          }
          text="Un aperçu des ambiances que nous créons sur le terrain, du vin d'honneur au bout de la nuit."
        />

        <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((item, i) => (
            <Reveal key={item.id || item.url} delay={i * 0.08} className={i % 2 === 1 ? "sm:mt-10" : ""}>
              <motion.figure
                whileHover={{ y: -6 }}
                transition={{ duration: 0.4 }}
                className="group relative overflow-hidden rounded-3xl border border-cyan-500/15"
                data-testid={`gallery-item-${i}`}
              >
                <img
                  src={item.url}
                  alt={item.caption}
                  loading="lazy"
                  className="aspect-[3/4] w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#080C14]/80 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <figcaption className="absolute bottom-4 left-4 right-4 flex items-center gap-2 text-xs font-semibold text-slate-100 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  <Camera size={13} className="text-cyan-300" />
                  {item.caption}
                </figcaption>
              </motion.figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
